
import { Component, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import ObservationMixin from '@/_mixins/observation'

import Container from '@/components/Placeholders/Container/Container.vue'

@Component({
    mixins: [ProjectMixin, ObservationMixin],
    components: { Container },
})
export default class DashboardIndex extends Mixins<MixinInterface>(ProjectMixin, ObservationMixin) {
    loaded = false
    accessible = false
    dashboards: Array<any> = []
    prevRoute: any = null
    ready = false
    unmounted = false

    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get dashboardId() {
        return this.$route.params.dashboardId ? this.$route.params.dashboardId : null
    }

    async mounted() {
        this.accessible = true

        if (this.project) {
            this.dashboards = await this.getDashboards({
                'filter[project]': this.project.id,
            }).catch(() => {
                //
            })
        }

        if (this.group) {
            this.dashboards = await this.getDashboards({
                'filter[projectGroup]': this.group.id,
            }).catch(() => {
                //
            })
        }

        this.handleDashboard()

        this.ready = true
    }

    // Getting project or group info from project API, if url is wrong or user hase no access to it show Container component with error text
    @Watch('dashboardId')
    handleDashboard() {
        if (this.unmounted) {
            return
        }

        let settings = this.userSettings.attributes.frontEndSettings
            ? JSON.parse(this.userSettings.attributes.frontEndSettings)
            : {}

        if (!this.dashboardId) {
            if (this.prevRoute) {
                if (this.$route.name != 'create-dashboard') {
                    this.$router.go(-1)
                }
            } else {
                if (this.dashboards.length > 0) {
                    let savedDashboardId
                    if (settings.currentDashboardId) {
                        let dashboard = this.dashboards.find(
                            (item) => item.id === settings.currentDashboardId
                        )
                        if (dashboard) {
                            savedDashboardId = settings.currentDashboardId
                        }
                    }

                    this.$router.replace({
                        name: 'dashboardId',
                        params: {
                            dashboardId:
                                savedDashboardId ||
                                this.defaultDashboard?.id ||
                                this.dashboards[0].id,
                        },
                    })
                } else {
                    this.$router.replace({ name: 'create-dashboard' })
                }
            }
        }

        this.prevRoute = this.dashboardId

        // check if dashboard exists, that is user enter invalid dashboard id in url
        let dashboard = this.dashboards.find((item) => item.id === this.dashboardId)
        if (dashboard && dashboard.id !== settings.currentDashboardId) {
            this.saveCurrentDashboard(dashboard.id)
        }
    }

    async saveCurrentDashboard(id: string) {
        let json = this.userSettings.attributes.frontEndSettings
            ? JSON.parse(this.userSettings.attributes.frontEndSettings)
            : { observationModule: {} }
        json.currentDashboardId = id
        let data: any = {
            type: this.userSettings.type,
            id: this.userSettings.id,
            attributes: {
                frontEndSettings: JSON.stringify(json),
            },
        }
        if (this.project) {
            await this.patchProjectUserSettings(data).catch(() => {
                //
            })
        }
        if (this.group) {
            await this.patchtGroupUserSettings(data).catch(() => {
                //
            })
        }
    }

    get userSettings() {
        return this.project
            ? this.$store.getters.projectUserSettings[
                  this.project.relationships.userSettings.data.id
              ]
            : this.$store.getters.groupUserSettings[this.group.relationships.userSettings.data.id]
    }

    get defaultDashboard() {
        return this.dashboards.find((item: any) => {
            return item.isDefault
        })
    }

    get projects() {
        // let projects: Array<any> = Object.values(this.$store.getters.projects)
        let projects: Array<any> = []
        this.group
            ? Object.values(this.$store.getters.projectModules).map((item: any) => {
                  item.relationships.module.data.id == 'observation'
                      ? projects.push(item.relationships.project.data.id)
                      : null
              })
            : (projects = [this.project.id])
        return projects
    }

    get routeReady() {
        return (
            this.$route.name == 'create-dashboard' ||
            (this.dashboardId && this.$store.getters.dashboard(this.dashboardId))
        )
    }

    beforeDestroy() {
        this.unmounted = true
    }
}
